import React from 'react'

import { Image } from '@src/quince-components/src'
import Video, { VIDEO_LOADING_TYPE, VIDEO_PRELOAD_TYPE } from '@src/quince-components/src/atoms/video'
import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import BundlePageSectionProps from '@src/quince-site-pdp/src/domains/BundlePageSectionProps'
import ProductPageSectionProps from '@src/quince-site-pdp/src/domains/ProductPageSectionProps'

import { getSectionDetailsForDevices } from '../../../helper/product.helper'

import { isFullBleedMediaSectionDataValid } from './fullBleedMedia.helpers'

// TODO: Cant find any entry on contentful regarding this section. Do we need this?
function FullBleedMedia(props: ProductPageSectionProps | BundlePageSectionProps) {
  const product = 'bundle' in props ? props.bundle : props.product
  const { desktopSectionDetails, mobileSectionDetails } = getSectionDetailsForDevices(
    product,
    CUSTOM_SECTION_TYPE.FULL_BLEED_MEDIA,
  )

  return (
    <>
      {desktopSectionDetails &&
        isFullBleedMediaSectionDataValid(desktopSectionDetails) &&
        renderSection(desktopSectionDetails, 'desktopOnly')}
      {mobileSectionDetails &&
        isFullBleedMediaSectionDataValid(mobileSectionDetails) &&
        renderSection(mobileSectionDetails, 'mobileOnly')}
    </>
  )
}

const renderSection = (sectionDetails: CustomSection, containerClassName: string) => {
  const imageTitle = sectionDetails.images ? sectionDetails.images[0]?.title : ''
  const imageUrl = sectionDetails.images ? `https:${sectionDetails.images[0]?.url}` : ''
  const videoUrl = sectionDetails.videos ? `https:${sectionDetails.videos[0]?.url}` : ''
  const videoProps = sectionDetails.videos ? sectionDetails.videos[0] : undefined
  if (videoUrl && videoProps) {
    return (
      <div className={containerClassName}>
        <Video
          {...videoProps}
          isPresentation
          muted
          autoplay
          loop
          controls={false}
          limitedControls
          loadingType={VIDEO_LOADING_TYPE.Lazy}
          preload={VIDEO_PRELOAD_TYPE.Auto}
        />
      </div>
    )
  }
  return (
    <div className={containerClassName}>
      <Image alt={imageTitle ?? ''} url={imageUrl} title={imageTitle ?? ''} />
    </div>
  )
}
export default FullBleedMedia
